import React from 'react'

import Base from '../_Base'

const India7 = (props) => (
  <Base width="59" height="22" viewBox="0 0 59 22" fill="none" {...props}>
    <path
      d="M56.6036 0C57.8511 0.00016821 58.7943 1.12998 58.5714 2.35742L55.2979 20.3574C55.125 21.3084 54.2967 22 53.3302 22H2.39656C1.14884 22 0.205758 20.8702 0.428784 19.6426L3.70124 1.64258C3.87415 0.691597 4.70245 0 5.66902 0H56.6036Z"
      fill="#4A4E58"
      fillOpacity="0.7"
    />
    <path
      d="M14.9856 5.38206H16.83L15.7263 12.034C15.607 12.7632 15.3286 13.4045 14.8911 13.9581C14.4569 14.5116 13.9034 14.9441 13.2306 15.2556C12.5578 15.5639 11.8087 15.718 10.9835 15.718C10.1515 15.718 9.4522 15.5639 8.88544 15.2556C8.31868 14.9441 7.90935 14.5116 7.65746 13.9581C7.40888 13.4045 7.34425 12.7632 7.46356 12.034L8.56726 5.38206H10.4117L9.33288 11.8799C9.26328 12.3042 9.29477 12.682 9.42734 13.0135C9.56323 13.3416 9.7853 13.6001 10.0935 13.789C10.4051 13.9779 10.7945 14.0724 11.2619 14.0724C11.7292 14.0724 12.1501 13.9779 12.5246 13.789C12.8992 13.6001 13.2058 13.3416 13.4444 13.0135C13.683 12.682 13.8371 12.3042 13.9067 11.8799L14.9856 5.38206Z"
      fill="#BBBBBB"
    />
    <path
      d="M22.866 4.90479L17.5762 17.0951H16.0002L21.29 4.90479H22.866Z"
      fill="#BBBBBB"
    />
    <path
      d="M22.9637 15.5639H20.995L26.2698 5.38206H28.5468L30.446 15.5639H28.4772L27.11 7.47013H27.0305L22.9637 15.5639ZM23.6896 11.5717H29.0589L28.8103 13.0532H23.441L23.6896 11.5717Z"
      fill="#BBBBBB"
    />
    <path
      d="M35.5332 15.5639L41.2853 6.99285L41.3052 6.92325H36.2739L36.5275 5.38206H43.4629L43.1994 6.95805L37.4472 15.5639H35.5332Z"
      fill="#BBBBBB"
    />
    <path
      d="M46.6782 13.9233L47.8118 7.04257H49.3778L48.2393 13.9233H46.6782ZM44.451 11.2635L44.7145 9.70734H51.5951L51.3316 11.2635H44.451Z"
      fill="#BBBBBB"
    />
  </Base>
)

export default India7
